const NAME = "CALCULATION_REFERENCES";

export default NAME;
